import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/koltuk-alti-terlemesi-icin-botoks-tedavisi/page.tsx");
